import { atom } from "recoil";
import { ImageData, markupDataParams, Step } from "../../types/markup";

export const zoomState = atom({
  key: "zoomState",
  default: 100,
});

export const controlState = atom({
  key: "controlState",
  default: "select",
});

export const stepState = atom({
  key: "stepState",
  default: 0,
});

export const markupState = atom({
  key: "markupState",
  default: "",
});

export const positionState = atom({
  key: "positionState",
  default: { x: 0, y: 0 },
});

export const imageNameState = atom({
  key: "imageNameState",
  default: "",
});

export const imageDataState = atom<ImageData>({
  key: "imageDataState",
  default: {} as ImageData,
});

export const pathologyImagesState = atom({
  key: "pathologyImagesState",
  default: {} as Record<string, Record<string, string>>,
});

export const markupPathologyState = atom({
  key: "markupPathologyState",
  default: {} as Record<string, markupDataParams[]>,
});

export const markupStepsState = atom({
  key: "markupStepsState",
  default: [] as Step[],
});

export const loadingState = atom({
  key: "loadingState",
  default: false,
});

export const brightnessState = atom({
  key: "brightnessState",
  default: 0,
});

export const contrastState = atom({
  key: "contrastState",
  default: 0,
});

export const pixelSpacingState = atom({
  key: "pixelSpacingState",
  default: 0,
});

export const regionState = atom({
  key: "regionState",
  default: "hip_joint",
});
